<template>
    <component :is="tag" v-intersect="{handler: onObserve, options: options}">
        <transition :name="transition" mode="out-in" appear>
            <slot v-if="isActive"/>
        </transition>
    </component>
</template>

<script>
import Toggleable from "../../mixins/Toggleable";

    export default {
        name: "Lazy",

        mixins: [Toggleable],

        props: {

            // The threshold of the IntersectionObserver
            threshold: {
                type: [Number, String],
                default: undefined
            },

            // The root of the IntersectionObserver
            root: {
                type: String,
                default: undefined
            },

            // The root margin of the IntersectionObserver
            rootMargin: {
                type: [Number, String],
                default: undefined
            },

            tag: {
                type: String,
                default: 'div',
            },
            transition: {
                type: String,
                default: 'fade-transition',
            },
        },

        computed: {
            // The options of the IntersectionObserver
            // For more information on types, navigate to:
            // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
            options() {
                return {
                    root: this.root,
                    rootMargin: this.rootMargin,
                    threshold: this.threshold
                }
            }
        },

        methods: {
            onObserve(isIntersecting) {
                if (this.isActive) {
                    return;
                }

                this.isActive = isIntersecting
            },
        }
    }
</script>